export default {
  isPhone: (value) => /^1[3456789]\d{9}$/.test(value),
  isEmpty: (value) => !!value === false || value.length === 0,
};

